import React, { Component } from "react";
import moment from "moment";

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.performAction = newType => {
      this.props.action(this.props.data, this.props.type, newType);
    };
    this.togglePopup = () => {
      var popupData = this.props.data;
      if (this.props.stakeData) {
        popupData = this.props.stakeData;
      }
      this.props.showPopup(popupData);
    };
    this.renderFooter = () => {
      switch (this.props.type) {
        case "admin":
          return (
            <>
              <span
                className="material-icons col-lg-6"
                onClick={this.performAction}
              >
                group_add
              </span>
            </>
          );
        // case "sellPipeline":
        case "adminBid":
          return (
            <>
              <span
                className="material-icons col-lg-6"
                onClick={this.togglePopup}
              >
                attach_money
              </span>
            </>
          );
        case "bid":
          return (
            <>
              <span
                className="material-icons col-lg-6"
                onClick={this.togglePopup}
                title="Bid"
              >
                check
              </span>
            </>
          );
        case "sellPipeline":
        case "bid_pipeline":
          return (
            <>
              <span
                className="material-icons col-lg-2"
                onClick={this.togglePopup}
                title="Check Bidders"
              >
                group
              </span>
              <span className="col-lg-10 text-center" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
            </>
          );
        case "new":
          return (
            <>
              <span
                className="material-icons col-lg-6"
                onClick={() => {
                  this.performAction("open");
                }}
                title="Interested"
              >
                check
              </span>
              <span
                className="material-icons col-lg-6 text-right"
                onClick={() => {
                  this.performAction("not_interested");
                }}
                title="Not Interested"
              >
                close
              </span>
            </>
          );
        case "open":
          return (
            <>
              <span className="col-lg-10 text-left" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
              <span
                className="material-icons col-lg-2 text-right"
                onClick={() => {
                  this.performAction("not_interested");
                }}
                title="Not Interested"
              >
                close
              </span>
            </>
          );
        case "sellOpen":
          return (
            <>
              <span
                className="material-icons col-lg-2 text-right"
                onClick={this.togglePopup}
                title="Not Interested"
              >
                close
              </span>
              <span className="col-lg-10 text-center" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
            </>
          );
        case "committed":
          return (
            <>
              <span className="col-lg-10 text-left" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
              <span
                className="material-icons col-lg-2 text-right"
                onClick={this.togglePopup}
                title="Sell"
              >
                attach_money
              </span>
            </>
          );
        case "sold":
        case "pipeline":
          return (
            <>
              <span className="col-lg-10 text-left" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
            </>
          );
        case "not_interested":
          return (
            <>
              <span className="col-lg-10 text-left" title="Last modified">
                <i className="im im-clock-o"></i>
                <span class="modified-time">
                  {moment(this.props.data.modified).fromNow()}
                </span>
              </span>
            </>
          );
        default:
          return null;
      }
    };
  }
  render() {
    return (
      <div className="card-footer">
        <div className="row startup-footer">{this.renderFooter()}</div>
      </div>
    );
  }
}
